import { render } from "./inspectionList.vue?vue&type=template&id=dc459a78"
import script from "./inspectionList.vue?vue&type=script&lang=js"
export * from "./inspectionList.vue?vue&type=script&lang=js"

import "./inspectionList.vue?vue&type=style&index=0&id=dc459a78&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__